module.exports = __webpack_public_path__ + "media/images/fancy_bathroom-c10860c2.webp";